import { render, staticRenderFns } from "./PancakeChart.vue?vue&type=template&id=85ae5f3c"
import script from "./PancakeChart.vue?vue&type=script&lang=js"
export * from "./PancakeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports